import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMinusMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconMinusMedium"><Path fillRule="evenodd" clipRule="evenodd" d="M4.5 12C4.5 11.7239 4.68655 11.5 4.91667 11.5H19.0833C19.3135 11.5 19.5 11.7239 19.5 12C19.5 12.2761 19.3135 12.5 19.0833 12.5H4.91667C4.68655 12.5 4.5 12.2761 4.5 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMinusMedium;
